<template>
    <form-container v-if="dataObject" headerText="Spielbericht" :button-cancel="labelButtonCancel"
                    :button-ok="labelButtonOk1" :button-ok-second="labelButtonOk2"
                    buttonOkSecondColor="success" :button-ok-color="colorButtonOk1" :noHistoryBackSpecial="true"
                    :width="1200" :action="action" breakpoint="smAndDown" @noHistoryBack="handleNoHistoryBack()"
                    :valid-actions="['confirmErgebnis','displayErgebnis','displayErgebnisAttest',
                                    'displayErgebnisDoppelstart','displayErgebnisSpielerHeim',
                                     'displayErgebnisSpielerGast']"
                    @save="reject()" @saveSecond="confirm()" :header-sub-text="subtitle"
                    :header-sub-text2="subtitle2">
        <spiel-status-text v-if="currentData || dataObject" :spiel="dataObject" class="text-center subtitle-1 spielStatusText"
                            long-text="true">
        </spiel-status-text>
        <div v-if="(setRealtime && !dataObjectRaw) || !dataObject" class="text-center my-10">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else-if="dataObject" class="tableContainer"><!-- currentData-->
            <div class="borderTop ">
                <table style="min-width: 860px">
                    <tr style="vertical-align: top">
                        <td class="pa-2" style="width: 50%">
                            <spiel-bericht-edit-confirm-team :data-object="dataObject" type="heim">
                            </spiel-bericht-edit-confirm-team>
                            </td>
                        <td class="pa-2" style="width: 50%">
                            <spiel-bericht-edit-confirm-team :data-object="dataObject" type="gast">
                            </spiel-bericht-edit-confirm-team>
                        </td>
                    </tr>
                </table>
            </div>
            <div class="mx-2 mb-3" style="min-width: 844px">
                <spiel-bericht-edit-result v-if="!dataObject.saison.isCup" :data-object="dataObject" :input="false"/>
                <spiel-bericht-edit-result-cup v-else :data-object="dataObject" :input="false"/>
            </div>
            <div class="mx-2 mb-3">
                <table class="borderTable text-center" style="min-width: 844px"><tr>
                        <td class="cell">Kapitän/in Heim:
                            <span class="font-weight-bold">{{dataObject.heim.captain}}</span>
                            <div v-if="dataObject.heim.protest" class="error--text">
                                <v-icon color="error" small class="mr-1 d-inline-block">mdi-alert</v-icon>
                                Protest eingelegt
                            </div>
                        </td>
                        <td class="cell">Schiedsrichter/in:
                            <span class="font-weight-bold">{{dataObject.referee.name}}</span></td>
                        <td class="cell">Kapitän/in Gast:
                            <span class="font-weight-bold">{{dataObject.gast.captain}}</span>
                            <div v-if="dataObject.gast.protest" class="error--text">
                                <v-icon color="error" small class="mr-1 d-inline-block">mdi-alert</v-icon>
                                Protest eingelegt
                            </div>
                        </td>
                </tr></table>
                <table v-if="dataObject.infos.kommentar || dataObject.infos.kommentarStrafe" class="borderTable mt-3" style="min-width: 844px"><tr>
                    <td class="cell px-3 py-2" style="position: relative; white-space: break-spaces;">
                        <span class="font-weight-bold">Kommentar: </span>{{dataObject.infos.kommentar}}
                        <div>{{dataObject.infos.kommentarStrafe}}</div>
                        <div class="printComment px-2">
                            <v-btn icon @click="openPrintKommentar">
                                <v-icon>mdi-printer</v-icon>
                            </v-btn>
                        </div>
                    </td>
                </tr></table>
            </div>
            <v-row no-gutters v-if="action==='confirmErgebnis'">
                <v-spacer></v-spacer>
                <v-col class="text-right shrink text-no-wrap pr-5">
                    <v-checkbox v-model="dataObject.gast.protest"
                                               hide-details class="pa-0 mb-3 text-right"
                                               label="als Gastverein Protest einlegen"></v-checkbox>
                </v-col>
            </v-row>

        </div>
        <confirm-dialog :open="confirmSave.open" :header="confirmSave.header"
                        :question="confirmSave.question"
                        @reply="processConfirm" query-parameter="confirmSpielbericht">
            <p v-if="confirmSave.dataMissing" class="error--text mt-2">
                Du kannst diese Aktion nicht mehr rückgängig machen!
            </p>
        </confirm-dialog>
        <error-msg :error="error"></error-msg>
        <v-btn v-if="$vuetify.breakpoint.smAndDown && action!=='confirmErgebnis'" fab dark bottom right
               color="primary" style="position: fixed; right: 15px; bottom: 15px; z-index: 15" @click="close()">
            <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <div class="printButton">
            <v-btn icon @click="openPrint()">
                <v-icon class="mr-2">mdi-printer</v-icon>
            </v-btn>
        </div>
    </form-container>
</template>

<script>
    import {db} from "../../../../services/db"
    import FormContainer from "../../../../components/form/formContainer";
    import ErrorMsg from "../../../../components/elements/errorMsg";
    import {Spiel} from "../../../../services/data/spiel";
    import ConfirmDialog from "../../../../components/navigation/confirmDialog";
    import SpielBerichtEditConfirmTeam from "./spielBerichtEditConfirmTeam";
    import SpielBerichtEditResult from "./spielBerichtEdit_result";
    import TimeStamp from "../../../../services/timeStamp";
    import SpielStatusText from "../../components/spielStatusText";
    import SpielBerichtEditResultCup from "@/views/ergebnisdienst/spielbericht/edit/spielBerichtEdit_resultCup";

    export default {
        components: {
            SpielBerichtEditResultCup,
            SpielStatusText,
            SpielBerichtEditResult,
            SpielBerichtEditConfirmTeam,
            ConfirmDialog, ErrorMsg, FormContainer},
        name: "spiel-bericht-edit-confirm",
        props: ['currentData', 'action', 'setRealtime'],
        data: () => ({
            dataObject: null,
            dataObjectRaw: null,
            error: '',
            confirmSave: {
                open: false,
                header: '',
                question: '',
                item: null,
                dataMissing: true,
            },
            updates: null,
            unsubscribe: null,
        }),
        computed: {
            user() { return this.$store.state.user; },
            subtitle(){ return this.dataObject.getSubTitle(); },
            subtitle2(){ return (this.dataObject && !this.setRealtime) || this.dataObjectRaw ?
                        this.dataObject.infos.bahn + ', ' + this.dataObject.infos.ort : ''},
            labelButtonOk1 () { return this.action === 'confirmErgebnis' ? 'ablehnen' : 'zurück' },
            colorButtonOk1 () { return this.action === 'confirmErgebnis' ? 'primary' : '' },
            labelButtonOk2 () { return this.action === 'confirmErgebnis' ? 'bestaetigen' : '' },
            labelButtonCancel () { return this.action === 'confirmErgebnis' ? 'abbrechen' : '' },
        },
        created(){
            console.log ("CREATED spielBerichtEditConfirm");
            this.dataObject = new Spiel();
            if ( this.setRealtime ) {
                this.setRawRealtimeData();
            } else if ( this.currentData ) {
                this.dataObject.setFromDataObject(this.currentData);
            }
        },
        destroyed() {
            if ( this.unsubscribe ) {
                console.log ("unsubscribe Listener" );
                this.unsubscribe();
            }
        },
        methods: {
            setRawRealtimeData(){
                let id = this.currentData && this.currentData.id ? this.currentData.id :
                         this.$route.query.spielId ? this.$route.query.spielId : '';
                if ( !id ) { return; }
                if ( this.unsubscribe ) { this.unsubscribe(); }
                this.unsubscribe = db.collection("spiele").doc(id)
                    .onSnapshot((doc) => {
                        this.dataObjectRaw = doc.data();
                        this.dataObjectRaw.id = doc.id;
                    });
            },
            close(){
                this.handleHistoryBack();
            },
            reject(){
                console.log ("reject");
                if ( this.action === 'confirmErgebnis' ) {
                // set updates
                    if ( !this.dataObject.vereine.confirmedGast ) {
                        this.dataObject.local.documentUpdates = {
                            ['vereine.confirmedGast']: TimeStamp.getGMTTimestamp(),
                            ['vereine.confirmedGastBy']: this.user.email,
                        };
                    } else {
                        this.dataObject.local.documentUpdates = {}
                    }
                    this.dataObject.local.documentUpdates['vereine.heim'] = this.dataObject.heim.vereinsNr + '_confirmed';
                    this.dataObject.local.documentUpdates['vereine.gast'] = this.dataObject.gast.vereinsNr + '_rejected';
                    this.dataObject.local.documentUpdates['vereine.alle'] = [ this.dataObject.heim.vereinsNr ,
                                                                              this.dataObject.gast.vereinsNr ];
                // set confirm
                    this.confirmSave.question = 'Möchtest du diesen Spielbericht ' +
                        'wirklich endgültig ablehnen?';
                    this.confirmSave.header = 'Spielbericht ablehnen';
                    this.confirmSave.open = true;
                } else {
                    this.handleHistoryBack();
                }
            },
            confirm(){
                console.log ("confirm");
            // set updates
                if ( !this.dataObject.vereine.confirmedGast ) {
                    this.dataObject.local.documentUpdates = {
                        ['vereine.confirmedGast']: TimeStamp.getGMTTimestamp(),
                        ['vereine.confirmedGastBy']: this.user.email,
                    };
                } else {
                    this.dataObject.local.documentUpdates = {}
                }
                this.dataObject.local.documentUpdates['vereine.heim'] = this.dataObject.heim.vereinsNr + '_confirmed';
                this.dataObject.local.documentUpdates['vereine.gast'] = this.dataObject.gast.vereinsNr + '_confirmed';
                this.dataObject.local.documentUpdates['vereine.alle'] = [ this.dataObject.heim.vereinsNr ,
                                                                          this.dataObject.gast.vereinsNr ];
                this.dataObject.local.documentUpdates['gast.protest'] = this.dataObject.gast.protest === undefined ?
                                                                            false: this.dataObject.gast.protest;
            // set confirm
                this.confirmSave.question = 'Möchtest du diesen Spielbericht ' +
                    'wirklich endgültig bestätigen? Hast du alle Punkte geprüft?';
                this.confirmSave.header = 'Spielbericht bestätigen';
                this.confirmSave.open = true;
            },
            processConfirm(reply) {
                if ( reply ) {
                    this.save();
                }
                this.confirmSave.open = false;
            },
            async save(){
                console.log ("SAVE CONFIRM");
            // save (updates already set during confirm dialog)
                this.$store.state.local.loader = true;
                let reply = await this.dataObject.saveEdited('spiel_edit');
                if ( reply.successful ) {
                    this.handleHistoryBack();
                } else {
                    this.error = this.dataObject.getDBErrorText(reply.content);
                }
                this.$store.state.local.loader = false;
            },
            openPrint(){
                let id = this.currentData && this.currentData.id ? this.currentData.id :
                    this.$route.query.spielId ? this.$route.query.spielId : '';
                let routeData = this.$router.resolve(
                    {name: 'PrintSpielbericht', query: {id: id}});
                window.open(routeData.href, '_blank');
            },
            openPrintKommentar(){
                let id = this.currentData && this.currentData.id ? this.currentData.id :
                    this.$route.query.spielId ? this.$route.query.spielId : '';
                let routeData = this.$router.resolve(
                    {name: 'PrintSpielberichtKommentar', query: {id: id}});
                window.open(routeData.href, '_blank');
            },
            handleHistoryBack(){
                if (document.referrer == "") {
                    this.handleNoHistoryBack();
                } else {
                    window.history.back();
                }
            },
            handleNoHistoryBack(){
                let p = JSON.parse(JSON.stringify(this.$route.path));
                let q = JSON.parse(JSON.stringify(this.$route.query));
                delete q.action;
                delete q.spielId;
                this.$router.replace({path: p, query: q});
            }
        },
        watch: {
            currentData(to, from) {
                if ( !from && to && !this.setRealtime ) {
                    this.dataObject.setFromDataObject(this.currentData);
                }
            },
            dataObjectRaw(to){
                if ( to ) {
                    this.dataObject.setFromDataObject(this.dataObjectRaw);
                }
            }

        }
    }
</script>

<style scoped>
    .printButton {position: absolute; top: 17px; right: 62px;}
    .tableContainer { width: 100%; overflow-x: auto;}
    .borderTop {border-top: solid 1px lightgrey;}
    table {width: 100%; border-spacing: 0; table-layout: auto;  }
    .cell {border-top: solid 1px grey; border-left: solid 1px grey; width: 33.33%;
          padding: 6px}
    .borderTable {border-right: solid 1px grey; border-bottom: solid 1px grey}
    .spielStatusText { position: absolute; width: 100%; bottom: 22px; }
    .printComment {position: absolute; right: 0; top: 2px}
</style>